import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { fetchGrammarTopics, deleteGrammarTopic } from "./adminGrammarService";
import GrammarTopicForm from "./GrammarTopicForm";
import "../../blog/tongueTwister.css";
import "./grammarForm.css";

const BASE_ROOT = process.env.REACT_APP_BASE_URL_ROOT || "";
const toPublicUrl = (url) => url?.replace(/\/api(?:\/admin)?\/media-images\//, "/api/public/media-images/") ?? url;
const toImgSrc = (url) => {
  if (!url) return "";
  const src = toPublicUrl(url.startsWith("http") ? url : `${BASE_ROOT}${url}`);
  console.log("[AdminGrammarTopicPage] img raw:", url, "→ resolved:", src);
  return src;
};

const AdminGrammarTopicPage = () => {
  const [items, setItems] = useState([]);
  const [editing, setEditing] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [deleteId, setDeleteId] = useState(null);
  const navigate = useNavigate();

  useEffect(() => { loadItems(); }, [page, search]); // eslint-disable-line

  const loadItems = async () => {
    setLoading(true);
    const res = await fetchGrammarTopics({ page, size: 20, search: search || undefined });
    console.log("[AdminGrammarTopicPage] API response:", res);
    if (res.status === 200 && res.data) {
      const content = res.data.content || [];
      console.log("[AdminGrammarTopicPage] items[0]:", content[0]);
      console.log("[AdminGrammarTopicPage] coverImageUrl sample:", content[0]?.coverImageUrl);
      console.log("[AdminGrammarTopicPage] toImgSrc sample:", toImgSrc(content[0]?.coverImageUrl));
      setItems(content);
      setTotalPages(res.data.totalPages || 0);
    } else {
      setItems([]);
    }
    setLoading(false);
  };

  const handleDelete = async (id) => {
    const res = await deleteGrammarTopic(id);
    if (res.status === 200 || res.status === 204) { setDeleteId(null); loadItems(); }
  };

  const onSaved = () => { setShowForm(false); setEditing(null); loadItems(); };

  return (
    <div className="admin-container">
      <div className="admin-header">
        <h2>Grammar Topics</h2>
        <button onClick={() => { setEditing(null); setShowForm((v) => !v); }}>
          {showForm ? "✕ Close" : "+ New Topic"}
        </button>
      </div>

      {showForm && (
        <GrammarTopicForm topic={editing} onSaved={onSaved} onCancel={() => { setShowForm(false); setEditing(null); }} />
      )}

      <div style={{ marginBottom: 16 }}>
        <input
          type="text" placeholder="Search grammar topics…" value={search}
          onChange={(e) => { setPage(0); setSearch(e.target.value); }}
          style={{ padding: "8px 12px", borderRadius: 6, border: "1px solid #ccc", width: 280 }}
        />
      </div>

      {loading ? <p>Loading…</p> : (
        <table className="announcement-table">
          <thead>
            <tr>
              <th>Cover</th><th>Icon</th><th>Title</th><th>Description</th><th>Sort</th><th>Sub-Topics</th><th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {items.length === 0 ? (
              <tr><td colSpan="7">No grammar topics found</td></tr>
            ) : items.map((t) => (
              <tr key={t.id}>
                <td>
                  {t.coverImageUrl
                    ? <img src={toImgSrc(t.coverImageUrl)} alt="cover" style={{ width: 48, height: 36, objectFit: "cover", borderRadius: 6, border: "1px solid #e2e8f0" }} />
                    : <span style={{ color: "#ccc", fontSize: 12 }}>—</span>}
                </td>
                <td style={{ fontSize: "1.4rem", textAlign: "center" }}>{t.icon || "—"}</td>
                <td>
                  <span style={{ color: "#019095", cursor: "pointer", fontWeight: 600 }}
                    onClick={() => navigate(`/admin/content/grammar/${t.id}`)}>
                    {t.title}
                  </span>
                </td>
                <td style={{ color: "#666", fontSize: 13 }}>{t.description}</td>
                <td style={{ textAlign: "center" }}>{t.sortOrder ?? "—"}</td>
                <td style={{ textAlign: "center" }}>{t.subTopicCount || 0}</td>
                <td>
                  <button onClick={() => { setEditing(t); setShowForm(true); }}>Edit</button>
                  {deleteId === t.id ? (
                    <>
                      <button className="delete-btn" onClick={() => handleDelete(t.id)}>Confirm</button>
                      <button onClick={() => setDeleteId(null)}>Cancel</button>
                    </>
                  ) : (
                    <button className="delete-btn" onClick={() => setDeleteId(t.id)}>Delete</button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {totalPages > 1 && (
        <div style={{ marginTop: 20 }}>
          <button disabled={page === 0} onClick={() => setPage(page - 1)}>Prev</button>
          <span style={{ margin: "0 10px" }}>Page {page + 1} / {totalPages}</span>
          <button disabled={page + 1 >= totalPages} onClick={() => setPage(page + 1)}>Next</button>
        </div>
      )}
    </div>
  );
};

export default AdminGrammarTopicPage;
